<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style type="text/css">
  body {
    padding:0px;
    margin:0px auto;
    overflow: hidden;
  }
</style>

<style type="text/css" scoped>
/deep/ .el-menu--popup {
  background-color: #1f5390;
}
/deep/ .el-menu--popup .el-menu-item-group__title {
  padding: 0;
}
/deep/ .el-menu--popup .el-menu-item:hover {
  background-color: rgba(0, 63, 109, 0.6);
}
/deep/ .el-dialog__header {
  background-color: #4fa0ea;
  color: #fff;
  line-height: 20px;
  padding: 10px 0 10px 20px;
}
/deep/ .el-dialog__headerbtn {
  top: 10px;
  right: 10px;
  font-size: 20px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: white
}
/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
  color: rgb(242, 242, 242)
}
/deep/ .content-main .header-wrapper {
  padding: 16px 0;
}
/deep/ .content-main .bread-wrapper {
  margin-bottom: 0;
}
/deep/ .header-wrapper .el-form--inline .el-form-item {
  margin-bottom: 0;
}
/deep/ .el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #fff;
  color: #606266;
  min-width: 30px;
  border-radius: 2px;
  border: 1px solid #DCDFE6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue